export enum OtpPurpose {
    Login = 1,
    SignUp = 2,
    ChangeMobileNumber = 3,
    VerifyEmail = 4,
    DocumentSignature = 5
}
export class WhatsAppConsent {
    customerId: string;
    optedOut: boolean;
    // tslint:disable-next-line
    number: string;
    // tslint:disable-next-line
    constructor(customerId: string, number: string, optedOut: boolean) {
        this.customerId = customerId;
        this.number = number;
        this.optedOut = optedOut;
    }
}
